<template>
  <div class="row justify-content-center">
    <!-- <div class="col-md-8"> -->
    <b-container class="col-md-8">
      <h3 class="text-center" style="margin-bottom: 30px;">Aggiorna PASSWORD</h3>
      <b-row align-v="center" class="my-5">
        <b-col class="text-center">
        <!-- <b-modal id="resetPwdModal" ref="resetPwdModal" centered hide-footer title="Reimposta PASSWORD"> -->
          <div class="d-block text-center">
            <h5>Inserisci l'indirizzo email di registrazione, riceverai un’email con le istruzioni per resettare la password.
            </h5>
          </div>
          <b-input-group prepend="@ email" class="mt-3">
            <b-form-input type="email" required v-model="email"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-success" @click="sendPwdResEmail(email)">INVIA</b-button>
            </b-input-group-append>
          </b-input-group>
          <p class="error" variant="error" style="margin: 20px;">{{ error.message }}</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { auth } from '../../firebase/config.js'

  export default {
    data() {
      return {
        email: '',
        password: '',
        error: {
          value: null,
          message: ''
        }
      }
    },
    methods: {
      sendPwdResEmail(email) {
        this.error.message = ''
        auth.sendPasswordResetEmail(email)
        .then(() => {
          // Password reset email sent!
          alert('Email di Password Reset inviata a ' + email + '.')
        })
        .catch((err) => {
          console.log('Error!', err)
          if(err.code === 'auth/user-not-found') {
            alert('Email inviata ad account ' + email + ' (se esistente in DogMotics).')
          }
          else
          {
            alert('Error! ...' + err.message)
          }
        });
        return
      },
    }
  };
</script>

<style>
  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-right: 10px !important;
    align-items: center
  }
  label {
    width: 30%;
    color: #555;
  }
  input {
    width: 70%;
    color: #111;
    border: 0px;
    border-bottom: 1px;
    border-bottom-color: #555;
  }
  .btn-primary {
    margin: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
    background: #bad300;
    border: #aac100;
    width: 40%;
    align-items: center
  }
  .btn-primary:hover {
    background: #777;
  }
  .btn-primary:a {
    background: #777;
  }
  .error {
    font-size: small;
    color: $#f81e47;
  }
</style>